angular.module('impactx.search').component('ixListPane', {
        require: {
            containerCtrl: '^ixListTabContainer'
        },
        bindings: {
            heading: '@',
            icon: '@',
            amount: '@'
        },
        controller: 'ListPaneCtrl',
        controllerAs: 'paneCtrl',
        templateUrl: 'modules/search/templates/list-pane.html',
        transclude: true
    }
);